<template>
    <rkm-form ref="RkmForm" showLegend>
        <rkm-area title="Login">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.email"
                        label="E-mail"
                        v-model="model.email"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.usuario"
                        label="Nome do Usuário"
                        :disabled="true"
                        v-model="model.usuario"
                    />
                </rkm-col>
                <rkm-col :cols="model.novaSenha ? 3 : 9">
                    <rkm-form-input
                        type="password"
                        :validations="validations.novaSenha"
                        label="Nova senha"
                        v-model="model.novaSenha"
                        placeholder="Para mudar sua senha, digite uma nova"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-input
                        v-if="model.novaSenha"
                        type="password"
                        :validations="validations.novaSenhaConfirmation"
                        label="Confirmar nova senha"
                        v-model="model.novaSenhaConfirmation"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-input
                        v-if="model.novaSenha"
                        type="password"
                        :validations="validations.senha"
                        label="Senha atual"
                        v-model="model.senha"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions, mapGetters } from 'vuex'

import { error, repository, stringCase } from '@/mixins'

export default {
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao'
        }),
        validations() {
            return {
                email: {
                    required: true,
                    min: 5,
                    max: 70
                },
                usuario: {
                    required: true,
                    min: 3,
                    max: 100
                },
                novaSenha: {
                    regex: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/
                },
                novaSenhaConfirmation: {
                    required: this.model.novaSenha ? true : false,
                    is: this.model.novaSenha
                },
                senha: {
                    required: this.model.novaSenha ? true : false,
                    regex: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/
                },
            }
        }
    },
    created() {
        this.repositories.usuarioPerfil = this.getConectaSusRepository('cadastro.usuarioPerfil')

        this.setLoading()
        this.repositories.usuarioPerfil.edit(this.autenticacao.usuario.id).then(response => {
            Object.assign(this.model, {
                email: response.data.email,
                usuario: response.data.usuario
            });
            this.unsetLoading()
        })
    },
    data: () => ({
        repositories: {
            usuarioPerfil: null
        },
        model: {
            email: null,
            usuario: null,
            senha: null,
            novaSenha: null,
            novaSenhaConfirmation: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.usuarioPerfil.update(
                        this.autenticacao.usuario.id,
                        this.camelObjectKeysToSnakeRecursive(this.model)
                    ).then(() => {
                        this.showSaveNotification()

                        this.model.senha = null;
                        this.model.novaSenha = null;
                        this.model.novaSenhaConfirmation = null;

                        this.$emit('save')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                })

        }
    },
    mixins: [ error, repository, stringCase ],
}
</script>